import { ROOT_DOCS_PATH } from './constants';

/**
 * Normalizes a path to ensure it has a leading slash and does not end with a slash
 */
export function normalizePath(path: string): string {
  return (path.startsWith('/') ? path : `/${path}`).replace(/\/$/, '');
}

/**
 * A helper to create a URL relative to the site root for a documentation page. Accepts a path that might be relative to the docs root path.
 */
export function makeDocsLink(
  path: string,
  root: string = ROOT_DOCS_PATH
): string {
  const normalizedPath = normalizePath(path);
  const normalizedRoot = normalizePath(root);

  // If for some reason the path is already complete, don't do anything
  if (normalizedPath.startsWith(normalizedRoot)) {
    return normalizedPath;
  }

  return `${normalizedRoot}${normalizedPath}`;
}

/**
 * A helper to determine if a URL is external.
 */
export function detectExternalLink(url: string): boolean {
  return url.includes('https://') ? true : false;
}

/**
 * Builds a link to edit a page at the given path on GitHub
 */
export function makeEditLink(path: string): null | string {
  if (path === 'index') return null;

  return `https://github.com/clerk/clerk-docs/edit/main/docs${normalizePath(
    path
  )}.mdx`;
}
